import React from 'react';

export default function AboutSection({ 
    id,
    title, 
    children,
    backgroundImage,
    backgroundColor = 'bg-beige',
    textColor = 'text-charcoal',
    overlayOpacity = 40,
    brightness = 0.6,
    onNavigateUp,
    onNavigateDown,
    showDoubleUp = false
}) {
    const bgClass = backgroundImage ? '' : backgroundColor;
    const colorClass = backgroundImage ? 'text-white' : textColor;

    return (
        <div 
            id={id} 
            className={`min-h-screen flex flex-col justify-center items-center relative overflow-hidden ${bgClass} py-12 md:py-16`}
        >
            {/* Blurred background image */}
            {backgroundImage && (
                <div 
                    className="absolute bg-cover bg-center"
                    style={{ 
                        backgroundImage: `url(${backgroundImage})`,
                        filter: `blur(1px) brightness(${brightness})`,
                        transform: 'scale(1.1)',
                        top: '-5%',
                        left: '-5%',
                        right: '-5%',
                        bottom: '-5%',
                        zIndex: 0
                    }}
                />
            )}
            
            {/* Dark overlay for better text readability */}
            {backgroundImage && (
                <div className={`absolute inset-0 bg-black/${overlayOpacity} z-0`} />
            )}

            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full">
                {title && (
                    <h1 className={`font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 ${colorClass} break-words`}>
                        {title}
                    </h1>
                )}
                <div className={`${colorClass} overflow-y-auto`}>
                    {children}
                </div>
            </div>
        </div>
    );
}
